import React from "react";
import { GrLogout } from "react-icons/gr";
import Logo from "../../assets/images/Logo-ttj/Siglă-bej-wide-fundal-mov.png";
import style from "./Navbar.module.css";

import { RootContext } from "../../context/RootProvider";
import { useContext, useState } from "react";

import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaUserCircle, FaLongArrowAltLeft, FaCalendarAlt, FaBars } from "react-icons/fa";
import { NavLink, Link } from "react-router-dom";
import Hamburger from "../Hamburger/Hamburger";

function Navbar() {
  const rootContext = useContext(RootContext);
  const navigate = useNavigate();
  const [isHamburgerOpen, setHamburgerOpen] = useState(false);

  function toggleHamburger(){
    if(isHamburgerOpen) setHamburgerOpen(false);
    else setHamburgerOpen(true);
  }

  function handleLogout() {
    rootContext.setUser(null);
    rootContext.setIsUserAdmin(false);

    navigate("/");
  }

  return (
    <nav className={style.navContainer}>
      <div className={style.hamburger}>
        <button id="deschideHamburger" className={style.hamburgerButton} onClick={() => toggleHamburger()}> {isHamburgerOpen ? <span className={style.icon}>X</span> : <FaBars className={style.icon}></FaBars>}</button>
       <div className={style.logoContainer}>
        <img className={style.logo} src={Logo} alt="ttj" />
        <div className={style.icon}></div>
      </div>
      <div className={style.placeholder}></div>
      </div>
      {isHamburgerOpen ? <Hamburger rootContext={rootContext}/> : null}
      <div className={style.navbar}>
      <Link to="https://ttj.sisc.ro/"
        className={`${style.navItem} ${style.onHover}`}
      >
        <FaLongArrowAltLeft className={style.icon}></FaLongArrowAltLeft>
        Înapoi la site
      </Link>


              <NavLink to="/" className={({isActive}) => isActive ? `${style.navItem} ${style.onHover} ${style.active}` : `${style.navItem} ${style.onHover}`}>
                  <FaUserCircle className={style.icon} />
                Profil
              </NavLink>

      <div className={style.logoContainer}>
        <img className={style.logo} src={Logo} alt="ttj" />
        <div className={style.icon}></div>
      </div>

             <NavLink to="/interviu" className={({isActive}) => isActive ? `${style.navItem} ${style.onHover} ${style.active}` : `${style.navItem} ${style.onHover}`}>
                  <FaCalendarAlt className={style.icon2} />
                Interviu
              </NavLink>

      <div
        onClick={handleLogout}
        className={`${style.navItem} ${style.onHover}`}
      >
        <FaSignOutAlt className={style.icon}></FaSignOutAlt>
        <p>Logout</p>
      </div>
      </div>
    </nav>
  );
}

export default Navbar;
